<template>
<div class="furnish-main">
  <el-descriptions title="" :column="1" border label-style="width: 120px;">
    <el-descriptions-item label="装修编号">
      <el-row>
        <el-col :span="16">
          <el-input size="mini" class="form-input" v-model="form.FitmentID" clearable autocomplete="off"></el-input>
        </el-col>
        <el-col :span="8">
          <el-button v-if="!form.FitmentID" size="mini" @click="getFitmentNumber('ZX',form.HouseID,'FitmentID')">获取</el-button><span style="color: red;margin-top: 5px;">*</span>
        </el-col>
      </el-row>
    </el-descriptions-item>
    <el-descriptions-item label="房产">
      <el-input size="mini" v-model="form.house_name" readonly></el-input>
    </el-descriptions-item>
    <el-descriptions-item v-if="!mainObj.id" label="操作">
      <el-button size="mini" type="primary" @click="setData">创建</el-button>
    </el-descriptions-item>
  </el-descriptions>
  <div style="height: 50px;"></div>
  <el-descriptions title="提供资料" :column="1" border label-style="width: 120px;">
    <el-descriptions-item label="图纸">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="图纸" />
    </el-descriptions-item>
    <el-descriptions-item label="证件要求">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="证件要求" />
    </el-descriptions-item>
  </el-descriptions>
  <div style="height: 50px;"></div>
  <el-descriptions title="填报资料" :column="1" border label-style="width: 120px;">
    <el-descriptions-item label="装修申请表">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="装修申请表" >
        <el-link type="primary" class="el-link-common" @click="getFile('装修申请表.docx')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="装修协议">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="装修协议">
        <el-link type="primary" class="el-link-common" @click="getFile('房屋装饰装修管理协议.doc')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="消防责任书">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="消防责任书" >
        <el-link type="primary" class="el-link-common" @click="getFile('单元防火责任书.docx')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="特种作业申请表">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="特种作业申请表" >
        <el-link type="primary" class="el-link-common" @click="getFile('特种作业申请表.docx')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="房屋完好确认表">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="房屋完好确认单">
        <el-link type="primary" class="el-link-common"  @click="getFile('房屋完好确认表.docx')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="其他资料">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="其他资料" >
<!--        <el-link type="primary" class="el-link-common">下载模板</el-link>-->
      </FitmentFileSubgroup>
    </el-descriptions-item>
  </el-descriptions>
<!--  <ViewFileList ref="ViewFileListRef" />-->
</div>
</template>

<script>
import ViewFileList from "../../../../Common/ViewFileList";
import FitmentFileSubgroup from "./components/FitmentFileSubgroup";
import AppConfig from "../../../../../../config/AppConfig";
export default {
  name: "DataEditor",
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  components: {FitmentFileSubgroup, ViewFileList},
  data(){
    return{
      form:{}
    }
  },
  activated() {
    this.getData()
  },
  mounted() {
    this.getData()
  },
  methods:{
    getFitmentNumber(top,house_id,value){
      const that=this;
      ERP.getRequest({url:"admin/HouseFurnish/getFitmentNumber",data:{top:top,house_id:house_id} },ret=>{
        if(ret.code){
          that.form[value]=ret.data;
        }else{
          that.$msgbox.alert(ret.msg||"获取失败")
        }
      })
    },
    setData(){
      const that = this;
      if(!that.form.HouseID){
        that.form.HouseID=that.mainObj.house_id;
      }
      ERP.postRequest({url:"admin/HouseFurnish/setFurnish",data:that.form},ret=>{
        if(ret.code){
          that.mainObj.id=ret.data.ID;
          that.form.ID=ret.data.ID;
          that.$msgbox.alert(ret.msg||"修改成功")
        }else{
          that.$msgbox.alert(ret.msg||"修改失败")
        }
      })
    },
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getFurnish",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.setProcessState(ret.data.ProcessState);
          // that.ProcessState=ret.data.ProcessState
          that.form=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    downloadFile(file_name) {
      const that = this;
      let url=ERP.getBaseURL()+"/admin/HouseFitmentFile/downloadFile?file_name="+file_name+"&fitment_id="+that.mainObj.id;
      window.open(url);
    },
    getFile(file_name) {
      // let url=AppConfig.erp_server+"/excel/house/"+file_name;
      let url=AppConfig.erp_server+"/admin/HouseFurnish/download?file_name="+file_name;
      window.open(url, "_blank");
    }
  }
}
</script>

<style lang="scss" scoped>
@import url(../../common.scss);
.furnish-main{
  height: calc(100vh - 230px);
  overflow-y: scroll;
  .el-link-common{
    margin-right: 20px;
  }
  :deep(.el-descriptions .is-bordered .el-descriptions-item__cell){
    border: 1px solid #5f5f5f;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/DataEditor.vue